// Документы старого Office (office_port/areas/documents). Меню нет: адрес Office /dict/document/document_id/N
// (ссылки в HTML функций БД read_provider_request_attorney_info / read_provider_request_invoice_info — экран
// «Заявки поставщику») открывает в My Space эту страницу: файл скачивается через office_port или, при выключенном
// OFFICE_PORT_DOCUMENTS, открывается Office, как раньше.
export const pages = {};

export const routes = [
  {
    path: "/office/documents/document/:document_id",
    alias: "/dict/document/document_id/:document_id",
    name: "officeDictDocument",
    meta: { layout: "main", title: "Документ" },
    component: () => import("@/views/office/documents/DictDocument.vue"),
  },
];
